module.exports = __webpack_public_path__ + "img/advantage5@2x.24344af9.png";